export default __webpack_public_path__ + "static/media/Innamorato.980acf8d.jpg";